export const LiveRegionTestIdFactory = {
    // bases
    getLiveRegionBase: () => 'live-region',
    // for test id generation
    getLiveRegionTestId: (testId) => [LiveRegionTestIdFactory.getLiveRegionBase(), testId].join('-'),
};
